import { HttpMethod, Service } from '../enums';
import { getDistributor } from '../utils';
export const getMailSubscriptionRequest = (email) => ({
    service: Service.WJIS,
    url: '/mail/subscribe/retail',
    method: HttpMethod.POST,
    data: {
        id: {
            email,
        },
        properties: {
            distributor: getDistributor(),
            placement: 'public_website_subscription_page',
        },
    },
    settings: {},
});
//# sourceMappingURL=mail.js.map